import { SiteSettings } from 'model';
import { FormValidationRules } from '../hooks/useFormValues';

export const siteSettingsRules: FormValidationRules<SiteSettings> = {
	description: {
		rules: {
			required: { value: true, message: 'Please enter a description for your site.' },
			minLength: { value: 10, message: 'Description must be at least {value} characters.' },
			maxLength: { value: 1000, message: 'Description must no more {value} characters long.' }
		}
	},
	siteName: {
		rules: {
			required: { value: true, message: 'Please enter a name for your site.' },
			maxLength: { value: 100, message: 'Name must be no more than {value} characters.' }
		}
	},
	legalName: {
		rules: {
			required: { value: true, message: 'Please enter a legal name for the operator of the site.' },
			maxLength: { value: 100, message: 'Legalname must be at least no more than {value} characters.' }
		}
	},
	welcomeEmail: {
		rules: {
			required: { value: true, message: 'Please enter a welcome email for new users.' },
			maxLength: { value: 2000, message: 'Welcome email must be no more than {value} characters.' }
		}
	},
	timezone: {
		rules: {
			required: { value: true, message: 'Please select a time zone.' }
		}
	},
	gettingStarted: {
		rules: {
			required: { value: true, message: 'Please enter a getting started message for new users.' },
			maxLength: { value: 2000, message: 'Getting started message must be no more than {value} characters.' }
		}
	},
	termsOfServiceVersion: {
		rules: {
			required: { value: true, message: 'Please enter a version number for your terms of service.' }
		}
	},
	termsOfService: {
		rules: {
			required: { value: true, message: 'Please enter a terms of service message for new users.' }
		}
	}
};
